import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-push-preview-dialog',
    templateUrl: './push-preview-dialog.component.html',
    styleUrls: ['./push-preview-dialog.component.scss'],
})
export class PushPreviewDialogComponent {
    constructor(
        public dialogRef: MatDialogRef<PushPreviewDialogComponent>,
        @Inject(MAT_DIALOG_DATA)
        public data: {
            title: string;
            body: string;
            cantidad?: number;
        },
    ) {}

    confirmar() {
        this.dialogRef.close(true);
    }

    cancelar() {
        this.dialogRef.close(false);
    }
}
